import React, {useState, useEffect} from 'react';
import {Grid, Typography, CssBaseline, Paper, Link} from "@mui/material";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {passwordRenewalMessageSent, sendRenewalMessage} from "../../auth/auth.actions";
import i18n from '../../../i18n';
import AppHeader from '../../../components/newComponents/AppHeader';
import { CompTextFieldNew } from '../../../components/newComponents/TextField';
import { ButtonPrimary } from '../../../components/newComponents/ButtonPrimary';
import { withRouter } from '../../utils/withRouter';

const ForgotPasswordComponent = ({t, sendRenewalMessage, match}) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState({});
    const [messageSent, setMessageSent] = useState(false);

    const logoLang = i18n.language === 'fi' ? 'Logo_nuodo_login_new2025' : 'Logo_ungdo_login_new2025';
    const logoSrc = `${process.env.PUBLIC_URL}/media/images/${logoLang}.svg`;

    useEffect(() => {
        document.title = `${t('login.forgot_password')} - ${t('common.title')}`;
    }, [t]);

    const handleChange = (event) => {
        setEmail(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!email) {
            setError({email: t("forgot_password.email_missing")});
            return;
        }
        setError({});
        sendRenewalMessage(email, () => {
            setMessageSent(true);
            return passwordRenewalMessageSent();
        });
    };

    const renderForm = () => (
        <form className='forgot-pw-form login-form' noValidate autoComplete="off" onSubmit={handleSubmit}> 
        {/* use same classname as in login form to avoid CSS class bloating */}
            <CompTextFieldNew
                variant="outlined"
                required
                fullWidth
                className='email-input login-input forgot-pw-input'
                id="email"
                isLabelShrink={true}
                label={t('forgot_password.email')}
                name="email"
                autoComplete="email"
                errorAlreadyTranslated={true}
                autoFocus
                error={error.email}
                onChange={handleChange}
                value={email}
            />
            <ButtonPrimary
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className='button-login' //rename classname for all new buttons?
                sx={{width: '200px', height: '40px', margin: '0px !important'}}
            >
                {t('forgot_password.send_button')}
            </ButtonPrimary>
                <Grid item xs sx={{marginTop: '15px'}}>
                    <Link href="/login" variant="body2">
                        {t('forgot_password.to_login')}
                    </Link>
                </Grid>
        </form>
    );

    const renderMessageSent = () => (
        <>
            {/* <Typography component="h1" variant="h5" gutterBottom>
                {t('forgot_password.message_sent_title')}
            </Typography> */}
            <Typography align='center' gutterBottom sx={{textAlign: 'left'}}>
                {t('forgot_password.message_sent_description')}
            </Typography>
            <ButtonPrimary
                fullWidth
                variant="contained"
                color="primary"
                href='/login'
                sx={{width: '200px', height: '40px', margin: '0px !important'}}
            >
                {t('forgot_password.to_login')}
            </ButtonPrimary>
        </>
    );

    return (
        <Grid className={'loginRoot'} sx={{paddingLeft: "0px !important", paddingRight: "0px !important", display: 'block'}}>
            <AppHeader />
            <CssBaseline/>

            <Grid className='site-wrapper loginBackgroundImage' sx={{width: '100%', paddingLeft: '20vh'}}> {/* ADD BACKGROUND IMAGE WHEN ITS READY */}
            <Grid className='login-box-wrapper' component={Paper} elevation={6} square size={{ xs: 12, sm: 9, md: 6 }} sx={{ height: '90vh'}}>
                <div className='paper forgot-pw-paper'>
                    <div className='paperHeader'>
                        <img className='login-logo'
                            src={logoSrc} alt={t('common.youth_work')} 
                        />
                    </div>
                    <Grid className={'paperContent forgot-pw_paperContent'}>
                        <Grid container spacing={messageSent ? 4 : 0} sx={{flexDirection: 'column'}}>
                            <Typography component="h1" variant='h4'>
                                {t('change_password.title')}
                            </Typography>
                        {!messageSent && (
                            <>
                                <Typography align='center' gutterBottom sx={{marginTop: '5%', textAlign: 'left'}}>
                                    {t('change_password.description')}
                                </Typography>
                            </>
                            )}
                            {messageSent ? renderMessageSent() : renderForm()}
                        </Grid>
                    </Grid>
                </div>
                <Grid container className={'footer-container forgot_pw_footer'}>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 4,
                                md: 3
                            }}>
                            <a href={'https://nuorisotilastot.fi/wp-content/uploads/2025/01/2025_01_07_Tietosuojailmoitus_nuodo.pdf'} target='_blank' rel="noopener noreferrer" className={'link-data-privacy'}>
                                {t('footer.privacy_statement')}
                            </a>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 4,
                                md: 3
                            }}>
                            <a href={'https://nuorisotilastot.fi/2350/uncategorized/nuodo-info/'} target='_blank' rel="noopener noreferrer" className={'link-accessibility'}>
                                {t('footer.accessibility_statement')}
                            </a>
        
                        </Grid>
                        <Grid /* sx={{width: '33%'}} */
                            size={{
                                xs: 12,
                                sm: 4,
                                md: 3
                            }}>
                            <div className={'copyright'}>© {t('common.application_owner')} {new Date().getFullYear()}</div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

const mapDispatchToProps = dispatch => ({
    sendRenewalMessage: (userEmail, onSuccess) => dispatch(sendRenewalMessage(userEmail, onSuccess)),
});

export const ForgotPassword = connect(null, mapDispatchToProps)(withTranslation('translation')(withRouter(ForgotPasswordComponent)));